// extracted by mini-css-extract-plugin
export default {"layout":"eKOkhI","title":"Y2n9zN","date":"SJcHPh","content":"hYIqWt","button":"O30QZa","footer":"kiaxGl"};